<template>
  <el-dialog append-to-body class="page-dialog center-dialog" :visible="visible" :title="title" width="1200px" @close="$emit('update:visible', false)" @closed="$emit('closed')">
    <div class="page-search" style="margin-bottom: 24px">
      <el-form ref="searchFormRef" :inline="true" :model="form" size="mini" label-width="64px" label-position="right">
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="代理账号">
              <el-input v-model="form.username" placeholder="请输入代理昵称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="代理编号">
              <el-input v-model="form.inviter_uid" placeholder="请输入代理编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="上级代理">
              <el-input v-model="form.inviter_username" placeholder="请输入邀请人昵称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align: right">
            <el-button type="primary" size="mini" @click="handleSearch">筛选</el-button>
            <el-button size="mini" @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table :data="list" border stripe size="small" fit highlight-current-row style="width: 100%">
      <el-table-column :resizable="false" type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column :resizable="false" prop="username" label="代理账号" width="200" align="center"></el-table-column>
      <el-table-column :resizable="false" prop="uid" label="代理编号" min-width="180" align="center"></el-table-column>
      <el-table-column :resizable="false" prop="inviter_username" label="上级代理" width="180" align="center"></el-table-column>
      <el-table-column :resizable="false" prop="share_num" label="直属下级人数" width="120" align="center"></el-table-column>
      <el-table-column :resizable="false" prop="agent_back_gold" label="已获得佣金" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.agent_back_gold | centsToYuan }}
        </template>
      </el-table-column>
      <el-table-column :resizable="false" prop="created_at" label="注册时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | formatTime }}
        </template>
      </el-table-column>
      <el-table-column :resizable="false" prop="login_at" label="最后登录时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.login_at | formatTime }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { AgentApi } from '@/api/agent'
import { parseTime } from '@/utils'

export default {
  name: 'AgentCountListDialog',
  filters: {
    formatGold(value) {
      if (value == null) {
        return '--'
      }
      return `${value.toFixed(2)}`
    },
    formatTime(value) {
      if (value == null) {
        return '--'
      }
      return parseTime(value)
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: '代理数量列表',
    },
  },
  data() {
    return {
      form: {
        inviter_uid: '',
        username: '',
        inviter_username: '',
      },
      page: 1,
      page_size: 10,
      total: 0,
      list: [],
      loading: false,
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.getAgentCountList()
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getAgentCountList() {
      this.loading = true
      const res = await AgentApi.getAgentCountList({
        agent_level: this.level,
        page: this.page,
        page_size: this.page_size,
        uid: this.form.inviter_uid || void 0,
        username: this.form.username || void 0,
        inviter_username: this.form.inviter_username || void 0,
      })
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    handleSearch() {
      this.getAgentCountList()
    },
    handleReset() {
      this.$refs.searchFormRef.resetFields()
      this.page = 1
      this.page_size = 10
      this.total = 0
      this.list = []
      this.form.inviter_uid = ''
      this.form.username = ''
      this.form.inviter_username = ''
      this.getAgentCountList()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getAgentCountList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getAgentCountList()
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination-container {
  margin-top: 24px;
  text-align: right;
}
</style>
